import React, { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import { Input, Checkbox, Radio, Select, Upload, message } from 'antd'
import { apiBaseURL } from '../config'

export default function Form() {
  const { TextArea } = Input
  const { oid } = useParams()
  const navigate = useNavigate()
  const [formInfo, setFormInfo] = useState({})
  const [formQuestions, setQuestions] = useState([])
  const [fileLists, setFileLists] = useState({})
  const [answers, setAnswers] = useState({})
  const [regions, setRegions] = useState([])
  const [submitting, setSubmitting] = useState(false)

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const consumerOid = searchParams.get('consumer_oid')
  
  useEffect(() => {
    axios.post('/c/forms/info/get', { 
      form_oid: oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormInfo(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
    
    axios.post('/c/forms/questions/get', { 
      form_oid: oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setQuestions(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [oid])

  useEffect(() => {
    if (formInfo.title) {
      document.title = formInfo.title
    }
  }, [formInfo])

  const uploadChange = (info, questionOid) => {
    const { fileList: newFileList, file } = info
    setFileLists(prev => ({
      ...prev,
      [questionOid]: newFileList // 按题目OID隔离
    }))
  
    if (file.status === 'done') {
      const imageUrl = file.response?.data?.image_url
      if (imageUrl) {
        setAnswers((prevAnswers) => {
          return {
            ...prevAnswers,
            [questionOid]: [
              ...(prevAnswers[questionOid] || []),
              imageUrl,
            ],
          }
        })
      }
    } else if (file.status === 'error') {
      message.error(`${file.name} 上传失败`)
    }
  }

  const handleImageRemove = (file, questionOid) => {
    const imageUrl = file.response?.data?.image_url
    if (imageUrl) {
      setAnswers(prev => ({
        ...prev,
        [questionOid]: (prev[questionOid] || []).filter(url => url !== imageUrl)
      }))
    }
  }

  const handleAnswerChange = (questionOid, value) => {
    setAnswers(prevAnswers => ({
      ...prevAnswers,
      [questionOid]: value
    }))
  }

  const handleRegionFocus = (superiorCode) => {
    axios.post(`${apiBaseURL}/common/region/get`, { 
      superior_code: superiorCode
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setRegions(response.data)
        } else {
          message.error(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleRegionChange = (questionOid, value, index) => {
    setAnswers(prevAnswers => {
      const currentAnswer = prevAnswers[questionOid] || []
      if (index === 0) {
        currentAnswer[1] = undefined
        currentAnswer[2] = undefined
      }
      currentAnswer[index] = value
      return {
        ...prevAnswers,
        [questionOid]: currentAnswer
      }
    })
  }

  const formSubmit = () => {
    if (submitting) {
      return
    }

    for (const question of formQuestions) {
      if (question.is_required && !answers[question.oid]) {
        message.error(`${question.title} 是必填项`)
        return
      }
    }

    setSubmitting(true)
  
    axios.post('/c/forms/submit', { 
      form_oid: oid,
      consumer_oid: consumerOid,
      answers: answers,
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAnswers({})
          setFileLists({})
          navigate(`/${oid}/success`, {
            state: { 
              resultPrompt: formInfo.result_prompt,
            }
          })
        } else {
          message.info(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
      .finally(function () {
        setSubmitting(false)
      })
  }

  return (
    <div className='form-page'>
      <div className='form-main'>
        <div className='form-info'>
          <div className='form-info-title'>
            {formInfo.title}
          </div>
          <div className='form-info-description'
            dangerouslySetInnerHTML={{__html: formInfo.description}}
          />
        </div>

        {formQuestions.map((question, index) => (
          <div className='form-question' key={question.oid}>
            <div className='form-question-required'>{question.is_required ? '*' : ''}</div>
            <div className='form-question-serialNumber'>{`${String(index + 1).padStart(2, '0')}`}</div>
            <div className='form-question-content'>
              <div className='form-question-content-title'>{question.title}</div>
              {question.description && 
                <div className='form-question-content-description'>{question.description}</div>
              }

              <div className='form-question-content-fill'>
                {question.type === 1 && 
                  <Input
                    placeholder='请输入'
                    value={answers[question.oid] || undefined}
                    onChange={e => handleAnswerChange(question.oid, e.target.value)}
                  />
                }
                {question.type === 2 && 
                  <TextArea
                    placeholder='请输入'
                    value={answers[question.oid] || undefined}
                    onChange={e => handleAnswerChange(question.oid, e.target.value)}
                  />
                }


                {/* {question.type === 3 && question.options.map((option) => (
                  <div key={option.oid} style={{ marginBottom: 8 }}>
                    <Radio
                      value={option.oid}
                      checked={answers[question.oid] === option.oid}
                      onChange={e => handleAnswerChange(question.oid, e.target.value)}
                    >
                      {option.value}
                    </Radio>
                    {option.is_input && answers[question.oid] === option.oid ? (
                      <div style={{ marginLeft: 24, marginTop: 8 }}>
                        <Input
                          placeholder='请输入'
                        />
                      </div>
                    ) : null}
                  </div>
                ))} */}

                {question.type === 3 && question.options.map((option) => (
                  <div key={option.oid} style={{ marginBottom: 8 }}>
                    <Radio
                      value={option.oid}
                      checked={
                        Array.isArray(answers[question.oid]) 
                          ? answers[question.oid][0] === option.oid 
                          : answers[question.oid] === option.oid
                      }
                      onChange={(e) => {
                        if (option.is_input) {
                          // 对于需要填空的选项，传递数组 ['选项值', '']
                          handleAnswerChange(question.oid, [e.target.value, ''])
                        } else {
                          // 普通选项，直接传递选项值
                          handleAnswerChange(question.oid, e.target.value)
                        }
                      }}
                    >
                      {option.value}
                    </Radio>
                    
                    {option.is_input ? (
                      Array.isArray(answers[question.oid]) && 
                      answers[question.oid][0] === option.oid
                    ) && (
                      <div style={{ marginLeft: 24, marginTop: 8 }}>
                        <Input
                          placeholder='请输入'
                          value={answers[question.oid][1] || ''}
                          onChange={(e) => {
                            // 更新填空值，保持选项值不变
                            handleAnswerChange(question.oid, [
                              answers[question.oid][0], 
                              e.target.value
                            ])
                          }}
                        />
                      </div>
                    ): null}
                  </div>
                ))}

                {question.type === 4 && question.options.map((option) => (
                  <Checkbox
                    key={option.oid}
                    value={option.oid}
                    checked={answers[question.oid]?.includes(option.oid)}
                    onChange={e => {
                      const newAnswers = [...(answers[question.oid] || [])]
                      if (e.target.checked) {
                        newAnswers.push(option.oid)
                      } else {
                        const index = newAnswers.indexOf(option.oid)
                        newAnswers.splice(index, 1)
                      }
                      handleAnswerChange(question.oid, newAnswers)
                    }}
                  >
                    {option.value}
                  </Checkbox>
                ))}
                {question.type === 5 &&
                  <Select
                    placeholder='请选择'
                    value={answers[question.oid] || undefined}
                    onChange={value => handleAnswerChange(question.oid, value)}
                    options={question.options.map(option => ({
                      value: option.oid,
                      label: option.value,
                    }))}
                  />
                }
                {question.type === 6 && 
                  <div className='form-question-content-region'>
                    <div className='form-question-content-region-select'>
                      <Select
                        placeholder='省'
                        value={(answers[question.oid] && answers[question.oid][0]) || undefined}
                        onChange={value => handleRegionChange(question.oid, value, 0)}
                        onFocus={() => handleRegionFocus('0')}
                        style={{width: '100%'}}
                        options={regions?.map(region => ({
                          value: region.code,
                          label: region.name,
                        }))}
                      />
                      <Select
                        placeholder='市'
                        value={(answers[question.oid] && answers[question.oid][1]) || undefined}
                        onChange={value => handleRegionChange(question.oid, value, 1)}
                        onFocus={() => handleRegionFocus(answers[question.oid][0])}
                        disabled={!answers[question.oid] || !answers[question.oid][0]}
                        style={{
                          width: '100%',
                          pointerEvents: !answers[question.oid] || !answers[question.oid][0] ? 'none' : 'auto',
                          cursor: !answers[question.oid] || !answers[question.oid][0] ? 'default' : 'pointer',
                          opacity: !answers[question.oid] || !answers[question.oid][0] ? 1 : 1
                        }}
                        options={regions?.map(region => ({
                          value: region.code,
                          label: region.name,
                        }))}
                      />
                      {(question.region_level === 2 || question.region_level === 3) && 
                        <Select
                          placeholder='区/县'
                          value={(answers[question.oid] && answers[question.oid][2]) || undefined}
                          onChange={value => handleRegionChange(question.oid, value, 2)}
                          onFocus={() => handleRegionFocus(answers[question.oid][1])}
                          disabled={!answers[question.oid] || !answers[question.oid][1]}
                          style={{
                            width: '100%',
                            pointerEvents: !answers[question.oid] || !answers[question.oid][1] ? 'none' : 'auto',
                            cursor: !answers[question.oid] || !answers[question.oid][1] ? 'default' : 'pointer',
                            opacity: !answers[question.oid] || !answers[question.oid][1] ? 1 : 1
                          }}
                          options={regions?.map(region => ({
                            value: region.code,
                            label: region.name,
                          }))}
                        />
                      }
                    </div>
                    {question.region_level === 3 && 
                      <div className='form-question-content-region-input'>
                        <Input
                          placeholder='请输入详细地址'
                          value={(answers[question.oid] && answers[question.oid][3]) || undefined}
                          onChange={e => handleRegionChange(question.oid, e.target.value, 3)}
                          disabled={!answers[question.oid] || !answers[question.oid][2]}
                          style={{
                            pointerEvents: !answers[question.oid] || !answers[question.oid][1] ? 'none' : 'auto',
                            cursor: !answers[question.oid] || !answers[question.oid][1] ? 'default' : 'pointer',
                            opacity: !answers[question.oid] || !answers[question.oid][1] ? 1 : 1
                          }}
                        />
                      </div>
                    }
                  </div>
                }
                {question.type === 7 && (
                  <Upload
                    name="image"
                    accept="image/*"
                    action={`${apiBaseURL}/common/image/upload`}
                    listType="picture-card"
                    fileList={fileLists[question.oid] || []}
                    beforeUpload={(file) => {
                      const isImage = file.type.startsWith('image/')

                      if (!isImage) {
                        message.error('只能上传图片格式')
                        return Upload.LIST_IGNORE
                      }

                      return true
                    }}
                    onChange={(info) => uploadChange(info, question.oid)}
                    onRemove={(file) => handleImageRemove(file, question.oid)}
                  >
                    {(fileLists[question.oid]?.length || 0) < 5 && '+ 上传图片'}
                  </Upload>
                )}
              </div>
            </div>
          </div>
        ))}

        <div className='form-submit'>
          <div className='form-button' onClick={formSubmit}>提交</div>
        </div>
      </div>
    </div>
  )
}
